module.exports = __webpack_public_path__ + "components/page-header/static/snow-badge-3a2f6d28368de94bbc01aeb5b5551e02.svg";